<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import Icon from "@/core/components/Icon"
  import NavegantesList from "@/domains/spl-navegantes/partials/NavegantesList"

  const formatRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{6}$/
  const regex =
    /^(?:\d{3}\.?\d{3}\.?\d{3}-?\d{2}|^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/
  export default {
    components: {
      Breadcrumbs,
      Icon,
      NavegantesList,
    },
    data: () => ({
      title: "SPL Navegantes",
      crumbs: [
        { name: "Início", path: "index" },
        { name: "SPL Navegantes", path: "spl-navegantes.index" },
        { name: "Cadastro", path: "spl-navegantes.show" },
      ],
      search: "",
      closed: 0,
      filter: null,
      idbeneficiario_search: "",
      document_search: "",
      status: "",
      my_tickets: [],
      allTickets: [],
    }),
    mounted() {
      document.title = `${this.title} - ${process.env.VUE_APP_TITLE}`
    },
    methods: {
      getTipoBeneficiario(status) {
        if (status === "1") {
          return "Estudante"
        }
        if (status === "2") {
          return "Trabalhador"
        }
        if (status === "3") {
          return "Estagiario"
        }
        return ""
      },
      getSituationRegister(situ) {
        const situation = String(situ)
        if (situation === "1") {
          return "INICIADO"
        }
        if (situation === "2") {
          return "ANALISADO"
        }
        if (situation === "3") {
          return "ATIVO"
        }
        if (situation === "4") {
          return "VENCIDO"
        }
        if (situation === "5") {
          return "PENDENTE"
        }
        if (situation === "6") {
          return "CANCELADO"
        }

        return ""
      },
      getFormattedDate(data) {
        if (data) {
          let dateObject = new Date(data)
          let day = String(dateObject.getDate()).padStart(2, "0")
          let month = String(dateObject.getMonth() + 1).padStart(2, "0")
          let year = dateObject.getFullYear()
          let formattedDate = `${day}/${month}/${year}`
          return formattedDate
        }
        // return "00/00/0000";
        return ""
      },
      getRoundTime(data) {
        if (!formatRegex.test(data)) {
          return ""
        }

        const currentDate = new Date()
        const paramDate = new Date(data)
        const difference = currentDate - paramDate

        if (difference >= 1000 * 60 * 60 * 24 * 365) {
          const years = Math.round(difference / (1000 * 60 * 60 * 24 * 365))

          return `há ${years === 1 ? "1 ano" : `${years} anos`}`
        }
        if (difference >= 1000 * 60 * 60 * 24) {
          const days = Math.round(difference / (1000 * 60 * 60 * 24))
          return `há ${days === 1 ? "1 dia" : `${days} dias`}`
        }
        if (difference >= 1000 * 60 * 60) {
          const hours = Math.round(difference / (1000 * 60 * 60))
          return `há ${hours === 1 ? "1 hora" : `${hours} horas`}`
        }
        if (difference >= 1000 * 60) {
          const minutes = Math.round(difference / (1000 * 60))
          return `há ${minutes === 1 ? "1 minuto" : `${minutes} minutos`}`
        }
        const seconds = Math.round(difference / 1000)
        return `há ${seconds === 1 ? "1 segundo" : `${seconds} segundos`}`
      },
      onStatusChange(status) {
        this.status = status
        this.onSearch()
      },
      pageList(array, pageNumber, pageSize) {
        return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
      },
      resetSearch() {
        this.document_search = ""
        this.onSearch()
      },
      async onSearch() {
        this.$Progress.start()
        try {
          let document_search = this.document_search

          if (regex.test(this.document_search)) {
            document_search = this.document_search.replace(/[^0-9]/gm, "")
          }
          if (document_search === "" && this.idbeneficiario_search === "") {
            this.$router.go(0)
          } else {
            const res = await this.$axios.post(
              "/api/spl-navegantes/beneficiarios",
              {
                take: "5000",
                search: document_search,
                idbeneficiario: this.idbeneficiario_search,
              }
            )
            if (res.data.sucess) {
              if (res.data.sucess.original?.error) {
                this.$toast.error({
                  message: "Não há registros para essa pesquisa.",
                })
              } else {
                const my_list = await Promise.all(
                  Object.entries(res.data.sucess).map((my_item) => {
                    const item = my_item[1]

                    if (item == null) {
                      return {}
                    }

                    const tipo_beneficiario = this.getTipoBeneficiario(
                      item.tpbeneficiario
                    )
                    const situacao_cadastro = this.getSituationRegister(
                      item.controle_registro?.idsituacao
                    )
                    const formattedDate = this.getFormattedDate(
                      item.controle_registro?.dtexpiracao
                    )
                    const roundTime = this.getRoundTime(
                      item?.doacao?.dtalteracao
                    )

                    return {
                      idbeneficiario: item.idbeneficiario,
                      matricula: item.idbeneficiario ?? "",
                      nome: item.nmnome ?? "",
                      cpf: item.usuario?.document_formatted ?? "",
                      beneficiario: tipo_beneficiario,
                      expiracao: formattedDate,
                      situacao: situacao_cadastro,
                      atualizacao: roundTime,
                      Opções: true,
                    }
                  })
                )

                this.my_tickets = this.pageList(my_list, 1, 6)
                this.allTickets = my_list
              }
            }
          }
        } catch (e) {
          this.$toast.error({
            message: e.response?.data?.message || e.response?.data?.error,
          })
        } finally {
          this.loading = false
          this.status = "finished"
          this.$Progress.finish()
        }
      },
    },
    computed: {
      pagination() {
        return {
          current_page: 1,
          first_page_url:
            "https://scmobi.sie.sc.gov.br/api/registry/person/organizations?page=1",
          from: 1,
          last_page: 1,
          last_page_url:
            "https://scmobi.sie.sc.gov.br/api/registry/person/organizations?page=1",
          next_page_url: null,
          path: "https://scmobi.sie.sc.gov.br/api/registry/person/organizations",
          // per_page: 15,
          per_page: 10,
          prev_page_url: null,
          to: 2,
          total: 10,
        }
      },
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-6" :crumbs="crumbs"/>
      <!-- ESTRUTURA DE GRID APLICADA A PARTIR DAQUI -->
      <div class="grid grid-cols-1 sm:grid-cols-2 mb-2">
        <div class="w-full lg:w-auto lg:mb-0">
          <router-link
            tag="button"
            class="form-new-green sm:py-1 w-full sm:w-auto"
            :to="{ name: 'spl-navegantes.step01' }"
          >
            <div class="flex items-center justify-center">
              <Icon icon="plus" class="h-4 mr-1 fill-current"/>
              Novo cadastro
            </div>
          </router-link>
        </div>
        <div
          class="flex flex-col justify-end flex-grow text-xs sm:flex-row sm:flex-wrap mt-2 sm:mt-0"
        >
          <form
            @submit.prevent="onSearch"
            class="flex flex-col w-full gap-2 sm:flex-row sm:w-auto sm:items-center"
          >
            <input
              v-model="idbeneficiario_search"
              class="pl-4 filter-search"
              type="text"
              placeholder="Pesquisar por Matrícula"
              title="Pesquisar por Matrícula"
            >
            <input
              v-model="document_search"
              class="pl-4 filter-search"
              type="text"
              placeholder="Pesquisar por Nome ou CPF"
              title="Pesquisar por Nome ou CPF"
            >
            <button
              class="flex items-center justify-center btn btn-primary"
              type="submit"
            >
              <Icon icon="search" class="h-4 mr-1 fill-current"/>
              Pesquisar
            </button>
          </form>
        </div>
      </div>
      <div>
        <NavegantesList
          ref="table"
          :closed="closed"
          :search="search"
          :filter="filter"
          :idbeneficiario="idbeneficiario_search"
          :my_document="document_search"
          :my_tickets="my_tickets"
          :allTickets="allTickets"
          :pagination="pagination"
          @setAllTickets="allTickets = $event"
          @refresh="my_tickets = $event"
        />
      </div>
    </div>
  </div>
</template>
